<template>
    <footer class="bg-gray-900 text-white py-10 px-6">
      <div class="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <!-- Logo & Tagline -->
        <div>
          <h3 class="text-2xl font-bold text-teal-400 mb-2">Magnum Dental Clinic Guwahati</h3>
          <p class="text-sm text-gray-300">Advanced Dental Care in Trusted Hands</p>
        </div>
  
        <!-- Contact Info -->
        <div>
          <h4 class="font-semibold text-white mb-3">Contact</h4>
          <ul class="text-sm space-y-1 text-gray-300">
            <li>📍 First Floor, Global Tower, Pathar Quarry, VIP Road, Guwahati- 781171, Assam, India</li>
            <li>📞 +91 8638940021</li>
            <li>✉️ magnumdentalclinic.mbdd@gmail.com</li>
          </ul>
        </div>
  
        <!-- Opening Hours -->
        <div>
          <h4 class="font-semibold text-white mb-3">Hours</h4>
          <ul class="text-sm space-y-1 text-gray-300">
            <li>Mon - Sun: 9:30 AM – 7:30 PM</li>
          </ul>
        </div>
  
        <!-- Quick Links -->
        <div>
          <h4 class="font-semibold text-white mb-3">Quick Links</h4>
          <ul class="text-sm space-y-1">
            <li><router-link to="/" class="text-gray-300 hover:text-white">Home</router-link></li>
            <li><router-link to="/dental-services" class="text-gray-300 hover:text-white">Treatments</router-link></li>
            <li><router-link to="/experienced-dentists-in-guwahati" class="text-gray-300 hover:text-white">Meet Our Doctors</router-link></li>
            <li><router-link to="/trusted-dental-clinic-in-guwahati" class="text-gray-300 hover:text-white">Why Choose Us</router-link></li>
            <li><router-link to="/dental-clinic-in-vip-road" class="text-gray-300 hover:text-white">Contact Us</router-link></li>
            <li><router-link to="/faq-dental-clinic-in-assam" class="text-gray-300 hover:text-white">Frequently Asked Questions</router-link></li>
          </ul>
        </div>
      </div>
  
      <!-- Bottom Bar -->
      <div class="mt-10 pt-6 border-t border-gray-700 text-center text-sm text-gray-400">
        <p>© 2025 Magnum Dental Clinic. All rights reserved.</p>
        <div class="mt-3 space-x-4">
          <a href="#" class="hover:text-white">🌐</a>
          <a href="#" class="hover:text-white">📘</a>
          <a href="#" class="hover:text-white">📸</a>
          <a href="#" class="hover:text-white">🐦</a>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'AppFooter'
  };
  </script>
  
  <style scoped>
  </style>
  